import * as React from 'react';
import { Icon } from '../../primitives/icon/icon';
/* tslint:disable */
var iconData = "\n<svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n<path d=\"M3.788 9.073l.71.72.712-.72 7.587-7.666L11.375 0l-6.86 6.962-3.092-3.128L0 5.24l3.788 3.833z\"></path>\n</svg>\n";
export var CheckIcon = function () { return React.createElement(Icon, { icon: iconData }); };
//# sourceMappingURL=check-icon.js.map